import React from 'react';
import { Form } from 'react-bootstrap';
import { CustomTextField } from '../../../shared/customTextField';
import * as yup from 'yup';
import { Formik } from 'formik';
import { CustomTextFieldPassword } from '../../../shared/customTextFieldPassword';

function UserInfoForm(props) {
    //yup validations
    const fullNameSchema = yup.object({
        firstName: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').test('first name Check', 'Required', function (item) {
            if (props.textboxStatus.is_full_name_activated === true) {
                if (!item) {
                    return false
                } else {
                    return true
                }
            } else {
                return true;
            }
        }),
        lastName: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').test('last name Check', 'Required', function (item) {
            if (props.textboxStatus.is_full_name_activated === true) {
                if (!item) {
                    return false
                } else {
                    return true
                }
            } else {
                return true;
            }
        }),
    });

    //yup validations
    const positionSchema = yup.object({
        position: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').test('position Check', 'Required', function (item) {
            if (props.textboxStatus.is_position_activated === true) {
                if (!item) {
                    return false
                } else {
                    return true
                }
            } else {
                return true;
            }
        }),
    });

    //yup validations
    const passwordSchema = yup.object({
        currentPassword: yup.string().min(8, 'Minimum length is 8 characters').trim().test('current password Check', 'Required', function (item) {
            if (props.textboxStatus.is_password_activated === true) {
                if (!item) {
                    return false
                } else {
                    return true
                }
            } else {
                return true;
            }
        }),
        newPassword: yup.string().min(8, 'Minimum length is 8 characters').trim().test('new password Check', 'Required', function (item) {
            if (props.textboxStatus.is_password_activated === true) {
                if (!item) {
                    return false
                } else {
                    return true
                }
            } else {
                return true;
            }
        }),
    });

    const emailSchema = yup.object({
        email: yup.string().email('Invalid Email').trim().matches(/^(.*)?\S+(.*)?$/, 'Spaces not allowed').nullable()
    })


    return (
        <div>
            <Formik
                enableReinitialize
                initialValues={{ fullName: (props.userData.first_name + ' ' + props.userData.last_name), firstName: props.userData.first_name, lastName: props.userData.last_name }}
                validationSchema={fullNameSchema}
                onSubmit={(values) => props.onSubmitUserName(values)}>
                {({
                    values,
                    errors,
                    handleChange,
                    handleSubmit,
                    submitCount
                }) => (
                    <Form noValidate>
                        {props.textboxStatus.is_full_name_activated === false ?
                            <CustomTextField
                                // isEditableAndToolTipEnabled={true}
                                isEditable={true}
                                disabled={true}
                                isAdminUser={props.userPremission.user_role === 0 ? true : false}
                                label="Full Name"
                                classLabel="disabledLabel"
                                controlId="fullName"
                                type="text"
                                value={values.fullName}
                                name="fullName"
                                classType="disabledTextBox"
                                handleOnChange={handleChange}
                                // onEditClick={props.userPremission.user_role !== 0 ? () => props.activateFullNameTextBox() : null}
                                onEditClick={() => props.activateFullNameTextBox()}
                                // toolTipId={"disablePipelinePermissionError"}
                                // toolTip={'Admin account name cannot be changed'}
                                // showToolTip={false}
                            />
                            :
                            <div>
                                <CustomTextField
                                    label="First Name"
                                    classLabel="defaultLabel"
                                    controlId="firstName"
                                    type="text"
                                    value={values.firstName}
                                    name="firstName"
                                    classType="savableAndCancelableTextBox"
                                    handleOnChange={handleChange}
                                    errorMessage={errors.firstName}
                                    isInvalid={submitCount > 0 && !!errors.firstName}
                                />
                                <CustomTextField
                                    isSavableAndCancelable={true}
                                    label="Last Name"
                                    classLabel="defaultLabel"
                                    controlId="lastName"
                                    type="text"
                                    value={values.lastName}
                                    name="lastName"
                                    classType="savableAndCancelableTextBox"
                                    handleOnChange={handleChange}
                                    onDeleteClick={() => props.deactivateNameTextBoxes()}
                                    onSaveClick={() => handleSubmit(values)}
                                    isOthersLoading={props.isPasswordSubmissionLoading ? true : false}
                                    isLoading={props.isNameSubmissionLoading ? true : false}
                                    errorMessage={errors.lastName}
                                    isInvalid={submitCount > 0 && !!errors.lastName}
                                />
                            </div>
                        }
                    </Form>
                )}
            </Formik>

            <Formik
                enableReinitialize
                initialValues={{ position: (props.userData.position), position: props.userData.position }}
                validationSchema={positionSchema}
                onSubmit={(values) => props.onSubmitUserPosition(values)}>
                {({
                    values,
                    errors,
                    handleChange,
                    handleSubmit,
                    submitCount
                }) => (
                    <Form noValidate>
                        {props.textboxStatus.is_position_activated === false ?
                            <CustomTextField
                                // isEditableAndToolTipEnabled={true}
                                isEditable={true}
                                disabled={true}
                                isAdminUser={props.userPremission.user_role === 0 ? true : false}
                                label="Position"
                                classLabel="disabledLabel"
                                controlId="position"
                                type="text"
                                value={values.position}
                                name="position"
                                classType="disabledTextBox"
                                handleOnChange={handleChange}
                                // onEditClick={props.userPremission.user_role !== 0 ? () => props.activatePositionTextBox() : null}
                                onEditClick={() => props.activatePositionTextBox()}
                                // toolTipId={"disablePipelinePermissionError"}
                                // toolTip={'Admin account position cannot be changed'}
                                // showToolTip={false}
                            />
                            :
                            <div>
                                <CustomTextField
                                    isSavableAndCancelable={true}
                                    label="Position"
                                    classLabel="defaultLabel"
                                    controlId="position"
                                    type="text"
                                    value={values.position}
                                    name="position"
                                    classType="savableAndCancelableTextBox"
                                    handleOnChange={handleChange}
                                    onDeleteClick={() => props.deactivatePositionTextBox()}
                                    onSaveClick={() => handleSubmit(values)}
                                    isOthersLoading={props.isPasswordSubmissionLoading ? true : false}
                                    isLoading={props.isPositionSubmissionLoading ? true : false}
                                    errorMessage={errors.position}
                                    isInvalid={submitCount > 0 && !!errors.position}
                                />
                            </div>
                        }
                    </Form>
                )}
            </Formik>

            <Formik
                enableReinitialize
                initialValues={{ email: props.userData.user_email }}
                validationSchema={emailSchema}
            //onSubmit={(values) => props.onSubmitUserName(values)}
            >
                {({
                    values,
                    errors,
                    handleChange,
                    handleSubmit,
                    submitCount
                }) => (
                    <Form noValidate>
                        <CustomTextField
                            isEditableAndToolTipEnabled={true}
                            disabled={true}
                            isAdminUser={true}
                            label="Email"
                            classLabel="disabledLabel"
                            controlId="email"
                            type="text"
                            value={values.email}
                            name="email"
                            classType="disabledTextBox"
                            handleOnChange={handleChange}
                            toolTipId={"disableEmailPermissionError"}
                            toolTip={`Please contact customer support via support@hiretrace.io`}
                            showToolTip={true}
                        />
                    </Form>
                )}
            </Formik>

            <Formik
                validationSchema={passwordSchema}
                onSubmit={(values) => props.onSubmitUserPassword(values)}
                initialValues={{ passwordPreview: '**********' }}>
                {({
                    values,
                    errors,
                    handleChange,
                    handleSubmit,
                    submitCount
                }) => (
                    <Form noValidate>
                        {props.textboxStatus.is_password_activated === false ?
                            <CustomTextField
                                isEditable={true}
                                disabled={true}
                                label="Password"
                                classLabel="disabledLabel"
                                controlId="password"
                                type="password"
                                value={values.passwordPreview}
                                name="password"
                                onEditClick={() => props.activatePasswordTextBox()}
                                classType="disabledTextBox"
                                handleOnChange={handleChange}
                            />
                            :
                            <div>
                                <CustomTextFieldPassword
                                    label="Current Password"
                                    classLabel="defaultLabel"
                                    controlId="currentPassword"
                                    type="password"
                                    value={values.currentPassword}
                                    name="currentPassword"
                                    classType="defaultTextBox"
                                    handleOnChange={handleChange}
                                    errorMessage={errors.currentPassword}
                                    isInvalid={submitCount > 0 && !!errors.currentPassword}
                                />
                                <CustomTextFieldPassword
                                    isSavableAndCancelable={true}
                                    label="New Password"
                                    classLabel="defaultLabel"
                                    controlId="newPassword"
                                    type="password"
                                    value={values.newPassword}
                                    name="newPassword"
                                    classType="defaultTextBox"
                                    handleOnChange={handleChange}
                                    onDeleteClick={() => props.deactivatePasswordTextBox()}
                                    onSaveClick={() => handleSubmit(values)}
                                    isOthersLoading={props.isNameSubmissionLoading ? true : false}
                                    isLoading={props.isPasswordSubmissionLoading ? true : false}
                                    errorMessage={errors.newPassword}
                                    isInvalid={submitCount > 0 && !!errors.newPassword}
                                />
                            </div>
                        }
                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default UserInfoForm;